// Copyright © Amazon.com and Affiliates: This deliverable is considered Developed Content as defined in the AWS Service Terms and the SOW between the parties dated 10/31/2024.

import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Route guard that checks if the AI feature is enabled in the current environment.
 * If not enabled, redirects to the home page.
 */
export const aiFeatureGuard = () => {
  const router = inject(Router);
  
  if (!environment.showAIButton) {
    // If AI feature is not enabled, redirect to home
    router.navigate(['/home']);
    return false;
  }
  
  return true;
};
